module.exports = __webpack_public_path__ + "static/Q5Answer2_Orange_LucasBenjamin-23541aec35b23e2f5231acf7dffc8bae.jpg";